export const WHITE_LIST = ['notFound', 'login'];

export const NOT_FOUND = 'notFound';

export const REDIRECT_ROUTE_NAME = 'Redirect';

export const DEFAULT_ROUTE_NAME = '首页';

export const DEFAULT_ROUTE = '/homePage/index';
